// extracted by mini-css-extract-plugin
module.exports = {"btn":"B_bb t_ry t_rl h_fp h_fD h_fs h_hf","full":"B_sP h_dp h_dz"};